import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '@/components/ui/command';
import { navGroups, platforms, platformItems, visibleFor } from './navigation';
import { basePath } from '@/lib/base';

export const AdminSearch = ({ open, onOpenChange, user, psp, triggerRef }) => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const groups = [
    ...navGroups.map((g) => ({ ...g, items: g.items.filter((i) => visibleFor(i, user, psp)).map((i) => ({ ...i, to: `${basePath()}${i.to}` })) })),
    ...platforms.map((p) => ({ title: p.label, items: platformItems(p.key).filter((i) => visibleFor(i, user, psp)).map((i) => ({ ...i, to: `${basePath()}${i.to}?platform=${p.key}` })) })),
  ];
  const select = (to) => { onOpenChange(false); navigate(to); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="admin-search-dialog p-0 gap-0" data-testid="admin-search-dialog"
        onOpenAutoFocus={(e) => { e.preventDefault(); inputRef.current?.focus(); }}
        onCloseAutoFocus={(e) => { e.preventDefault(); triggerRef?.current?.focus(); }}>
        <DialogTitle className="sr-only">Accès rapide</DialogTitle>
        <DialogDescription className="sr-only">Rechercher une page du back-office</DialogDescription>
        <Command>
          <CommandInput ref={inputRef} placeholder="Rechercher une page…" aria-label="Rechercher une page" data-testid="admin-search-input" className="h-14 pr-10" />
          <CommandList className="max-h-[60vh] p-2" data-testid="admin-search-results">
            <CommandEmpty data-testid="admin-search-empty">Aucune page trouvée.</CommandEmpty>
            {groups.filter((g) => g.items.length).map((group) => (
              <CommandGroup key={group.title} heading={group.title}>
                {group.items.map((item) => (
                  <CommandItem key={item.testid} value={`${group.title} ${item.label}`} onSelect={() => select(item.to)} data-testid={`search-${item.testid}`} className="min-h-11 gap-3 px-3 cursor-pointer">
                    <item.icon className="h-4 w-4 text-muted-foreground" />
                    <span className="flex-1">{item.label}</span><ArrowUpRight className="h-3.5 w-3.5 text-muted-foreground" />
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
};